<template>
    <div
        :class="[
            'sub-status-card',
            authStore.user?.license && authStore.user?.license?.owner && authStore.user?.license?.display !== 'Signature'
                ? 'cursor-pointer'
                : 'cursor-default'
        ]"
    >
        <div class="not-pro-status" v-if="!person?.license">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-white" viewBox="0 0 256 256">
                <path
                    d="M53.92,34.62A8,8,0,0,0,40.26,42,16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1.36-.37,31.27-8.78,57.09-34.72l14.89,16.38a8,8,0,1,0,11.84-10.76Zm74.07,189a128.48,128.48,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56h3.71L176.41,193.15A129.26,129.26,0,0,1,128,223.62ZM224,56v56c0,20.58-3.89,39.61-11.56,56.59A8,8,0,1,1,197.86,162c6.73-14.89,10.14-31.71,10.14-50V56L98.52,56a8,8,0,1,1,0-16H208A16,16,0,0,1,224,56Z">
                </path>
            </svg>

            <p>Unlicensed</p>

            <div class="flex-1"></div>

            <p class="upgrade-text" @click="subscribe({ type: PurchaseType.PURCHASE, for: store.person?.id })">Purchase</p>
        </div>

        <div class="pro-status" v-else @click="handleLicenseClick" :class="{ 'cursor-pointer': isClickableLicense }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                <path
                    d="M13 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.79289C2.10536 2.98043 2 3.23478 2 3.5V7C2 10.295 3.595 12.2919 4.93313 13.3869C6.37437 14.5656 7.80813 14.9656 7.87063 14.9825C7.95656 15.0059 8.04719 15.0059 8.13313 14.9825C8.19563 14.9656 9.6275 14.5656 11.0706 13.3869C12.405 12.2919 14 10.295 14 7V3.5C14 3.23478 13.8946 2.98043 13.7071 2.79289C13.5196 2.60536 13.2652 2.5 13 2.5ZM10.855 6.85375L7.355 10.3538C7.30856 10.4002 7.25342 10.4371 7.19272 10.4623C7.13202 10.4874 7.06696 10.5004 7.00125 10.5004C6.93554 10.5004 6.87048 10.4874 6.80978 10.4623C6.74908 10.4371 6.69394 10.4002 6.6475 10.3538L5.1475 8.85375C5.05368 8.75993 5.00097 8.63268 5.00097 8.5C5.00097 8.36732 5.05368 8.24007 5.1475 8.14625C5.24132 8.05243 5.36857 7.99972 5.50125 7.99972C5.63393 7.99972 5.76118 8.05243 5.855 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375H10.855Z"
                    fill="#F6BB1E" />
            </svg>
            <p>{{ person?.license?.type }} License</p>
        </div>

        <div class="divider"></div>

        <div class="status-wrapper">
            <div class="sub-status-item" @click="handleActiveProtectionClick" :class="{ 'cursor-pointer': isClickableItem }">
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-zinc-700" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>Active </span>Protection</p>
            </div>

            <div class="sub-status-item cursor-pointer" @click="handleDataBrokersClick" >
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-zinc-700" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatNumber(statsData?.data_brokers) }} </span> Data Brokers</p>
            </div>

            <div class="sub-status-item">
                <CheckIcon v-if="authStore.user?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-zinc-700" viewBox="0 0 256 256">

                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatNumber(statsData?.custom_sites) }}</span> Custom Sites</p>
            </div>

            <div class="sub-status-item">
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-zinc-700" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatTimeFromMinutes(authStore.user?.stats?.time_saved) }}</span> Time Saved</p>
            </div>
        </div>
        <!-- <PrimeButton @click="subscribe({ type: PurchaseType.UPGRADE, license: license! })" v-if="authStore.user?.license && authStore.user?.license?.owner && authStore.user?.license?.display !== 'Signature'" label="Modify License"
            variant="contrast" class="upgrade-btn" :disabled="authStore.user?.license?.display === 'Signature'" /> -->
    </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { CheckIcon } from '@heroicons/vue/24/outline';
import { useSubscriptionHelper } from '~/composables/subscriptionHelper';
import { PurchaseType } from '~/types/licenses/licenses';
import { ModalNames } from '~/types/modals';
import type { License } from '~/types/person/person';


const authStore = useAuthStore();
const store = usePersonStore();
const router = useRouter();
const { formatNumber, formatTimeFromMinutes } = useUtils();
const { showError } = useGlobalToast();

const license = ref<License | null>(null);

const { person } = storeToRefs(store);
const globalStore = useGlobalStore();
const { statsData } = storeToRefs(globalStore);

// Use computed to wait for stores to be populated
const isReady = computed(() => authStore.user && store.person);

// Set license when stores are ready
watch(isReady, (ready) => {
    if (ready) {
        license.value = store.person?.license!;
    }
}, { immediate: true });

const { subscribe } = useSubscriptionHelper();

// Check if license is signature
const isSignatureLicense = computed(() => {
    return person.value?.license?.type?.toLowerCase() === 'signature';
});

// Check if user can upgrade license (owns the license)
const canUpgradeLicense = computed(() => {
    const license = person.value?.license;
    const personId = person.value?.id;
    
    return !isSignatureLicense.value && 
           license?.owner?.type === 1 && 
           license?.owner?.id === personId;
});

// Computed properties for clickability
const isClickableLicense = computed(() => canUpgradeLicense.value);
const isClickableItem = computed(() => canUpgradeLicense.value);

// Click handlers
const handleLicenseClick = () => {
    if (canUpgradeLicense.value) {
        useDynamicDialog(ModalNames.PURCHASE_LICENSES, {
            type: PurchaseType.UPGRADE,
            license: person.value?.license!
        });
    }
};

const handleActiveProtectionClick = () => {
    if (canUpgradeLicense.value) {
        useDynamicDialog(ModalNames.PURCHASE_LICENSES, {
            type: PurchaseType.UPGRADE,
            license: person.value?.license!
        });
    }
};

const handleDataBrokersClick = () => {
    router.push('/brokers');
};
</script>

<style lang="scss" scoped>
.sub-status-card {
    @apply mx-4 p-4 rounded-md bg-zinc-900;

    .not-pro-status {
        @apply flex items-center gap-2 pb-3;

        p {
            @apply font-semibold text-sm text-white;
        }

        .upgrade-text {
            @apply text-amber-400 text-right font-semibold text-sm hover:underline cursor-pointer;
        }
    }

    .divider {
        @apply bg-zinc-800 h-px mb-3 w-full;
    }

    .pro-status {
        @apply flex pb-3 items-center gap-2 self-stretch;

        p {
            @apply text-white;
        }
    }

    .sub-status-item {
        @apply flex items-center gap-2;

        p {
            @apply text-zinc-400;

            span {
                @apply text-white font-medium;
            }
        }
    }
}

.status-wrapper {
    @apply gap-2 flex flex-col;
}

.check-icon {
    @apply h-6 w-6 text-amber-400;
}

.upgrade-btn {
    @apply mt-6 w-full bg-zinc-800;
    border: 1px solid transparent !important;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    position: relative;
    z-index: 1;
}

.upgrade-btn:hover {
    @apply bg-zinc-700 text-amber-400;
}

.upgrade-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
    pointer-events: none;
}
</style>
